// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kCOS-","col":"styles_col__3yiWX"};